export const messages = {
  en: {
    "a11y.skip": "Skip to content",
    "brand.tagline": "Objects shaped for your story",
    "nav.home": "Home",
    "nav.shop": "Shop",
    "nav.custom": "Your design",
    "nav.idea": "From an idea",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.open": "Open navigation",
    "nav.close": "Close navigation",
    "nav.locale": "Switch to Arabic",
    "nav.theme": "Change color theme",
    "nav.cart": "Open cart",
    "hero.eyebrow": "Made in Egypt, shaped by hand",
    "hero.title": "Craft with a point of view.",
    "hero.body":
      "Discover lasting objects, ready now or configured around the way you live.",
    "hero.cta": "Explore the collection",
    "home.featured": "Selected for your space",
    "home.featuredBody":
      "Small runs, honest materials and details worth keeping close.",
    "home.forAudience": "Picked for {audience}",
    "home.forAudienceBody":
      "Our makers ranked these pieces for you. Change your choice any time.",
    "home.forAudienceEmpty":
      "We are still curating pieces for this group — here is what is new.",
    "audience.eyebrow": "Welcome to Zoya",
    "audience.title": "Who are you shopping as?",
    "audience.body":
      "Pick the group that fits you best and we will lead with the pieces made for it.",
    "audience.skip": "Skip — show me everything",
    "audience.close": "Close and show everything",
    "audience.change": "Change",
    "audience.choose": "Personalize",
    "audience.current": "Shopping as",
    "home.reel.label": "Latest at Zoya",
    "home.reel.eyebrow": "Zoya now",
    "home.reel.title": "Objects, notes and delivery news",
    "home.reel.body":
      "A live view of what is published and what the workshop is preparing.",
    "home.reel.pause": "Pause announcements",
    "home.reel.resume": "Resume announcements",
    "home.reel.announcement.label": "Workshop note",
    "home.reel.announcement.title": "Custom design discovery is open",
    "home.reel.announcement.body":
      "Upload a production-ready design through an active published service, then configure material and dimensions with server-confirmed pricing.",
    "home.reel.delivery.label": "Delivery update",
    "home.reel.delivery.title": "Delivery details stay clear",
    "home.reel.delivery.body":
      "Service areas and dates are confirmed before ordering becomes available.",
    "home.reel.product.label": "Published object",
    "home.reel.view": "View object",
    "home.categories": "Find your starting point",
    "home.ready": "Ready objects",
    "home.readyBody":
      "Finished pieces with their own character, available as published.",
    "home.customizable": "Made personal",
    "home.customizableBody":
      "Choose from clear, workshop-approved materials and finishes.",
    "home.story": "Made slowly. Used fully.",
    "home.storyBody":
      "Zoya joins considered design with the knowledge of hands. Each published object carries the exact choices the workshop can honor.",
    "journey.design.title": "Bring your own design",
    "journey.design.body":
      "Upload your own production file directly. This request is independent of catalog products and is reviewed by the workshop before quotation or ordering.",
    "journey.design.cta": "Browse customer-design products",
    "designRequest.boundary":
      "This is a private design request—not a catalog product, cart item or order. The workshop confirms feasibility and price first.",
    "designRequest.eyebrow": "Standalone design intake",
    "designRequest.title": "Send your design to the workshop",
    "designRequest.body":
      "Attach the exact file you want us to review and add the practical details that will help production assess it.",
    "designRequest.step1": "Upload the private source design.",
    "designRequest.step2": "Add quantity, timing and production notes.",
    "designRequest.step3":
      "Review the workshop quotation before an order is created.",
    "designRequest.projectTitle": "Request title",
    "designRequest.quantity": "Quantity",
    "designRequest.targetDate": "Preferred date (optional)",
    "designRequest.quoteBoundary":
      "Submitting does not create an order or charge you. Pricing follows technical review and an explicit quotation.",
    "designRequest.submit": "Send design for review",
    "designRequest.submitting": "Sending securely…",
    "designRequest.success": "Design request received. Reference:",
    "designRequest.error": "We could not submit this design request",
    "journey.idea.title": "Begin with an idea",
    "journey.idea.body":
      "Explore published idea-to-product services. Work that needs human scoping stays clearly quote-required and never presents a false instant price.",
    "journey.idea.cta": "Browse idea-to-product services",
    "ideaRequest.eyebrow": "Quote-first workshop intake",
    "ideaRequest.title": "Tell us what you want to make",
    "ideaRequest.body":
      "Share a clear brief. The workshop will review feasibility, materials, timing and price before any commercial order is created.",
    "ideaRequest.step1": "Submit the idea and practical requirements.",
    "ideaRequest.step2":
      "A supervisor assigns the brief for technical scoping.",
    "ideaRequest.step3":
      "Review and accept the quotation before production begins.",
    "ideaRequest.projectTitle": "Project title",
    "ideaRequest.description": "Idea and production requirements",
    "ideaRequest.quantity": "Quantity",
    "ideaRequest.targetDate": "Preferred date (optional)",
    "ideaRequest.budget": "Budget in EGP (optional)",
    "ideaRequest.quoteBoundary":
      "This submits a request, not an order or payment. An order is created only after you accept the issued quotation.",
    "ideaRequest.submit": "Send idea for review",
    "ideaRequest.submitting": "Sending securely…",
    "ideaRequest.unavailable": "Idea service is currently unavailable",
    "ideaRequest.success": "Request received. Reference:",
    "ideaRequest.error": "We could not submit this request",
    "journey.boundary":
      "Only active workshop publications appear here. Pricing and manufacturing availability are confirmed from the current publication.",
    "journey.offerings": "Available ways to begin",
    "journey.offeringsBody":
      "Choose a published service to review its requirements, availability and pricing path.",
    "catalog.eyebrow": "The current publication",
    "catalog.title": "Objects with a clear origin",
    "catalog.body":
      "Browse only active Zoya publications. Draft workshop work never appears here.",
    "catalog.all": "All",
    "catalog.ready": "Ready",
    "catalog.customizable": "Customizable",
    "catalog.customerDesign": "Your design",
    "catalog.idea": "From an idea",
    "catalog.typeFilter": "Product type",
    "catalog.filters": "Refine collection",
    "catalog.filterBody": "Choose a journey, then narrow by price.",
    "catalog.search": "Search",
    "catalog.searchPlaceholder": "Search the collection",
    "catalog.searchButton": "Search",
    "catalog.clearSearch": "Clear search",
    "catalog.sort": "Sort by",
    "catalog.sortNewest": "Newest",
    "catalog.sortPriceAsc": "Price: low to high",
    "catalog.sortPriceDesc": "Price: high to low",
    "catalog.price": "Price",
    "catalog.minPrice": "Minimum price (EGP)",
    "catalog.maxPrice": "Maximum price (EGP)",
    "catalog.priceHelp":
      "Whole EGP amounts. Quote-required products are hidden while a price range is applied.",
    "catalog.priceInvalid": "Enter a valid non-negative whole EGP amount.",
    "catalog.priceInverted":
      "Maximum price must be greater than or equal to minimum price.",
    "catalog.applyPrice": "Apply price",
    "catalog.clearPrice": "Clear price",
    "catalog.loading": "Preparing the collection",
    "catalog.results": "published objects",
    "catalog.resultsTitle": "Published collection",
    "catalog.imagePending": "Image coming soon",
    "catalog.empty": "No active objects match this view.",
    "catalog.error": "The collection could not be loaded.",
    "action.retry": "Try again",
    "action.view": "View object",
    "action.configure": "Configure",
    "action.quote": "Request a Quote",
    "action.unavailable": "Temporarily unavailable",
    "product.back": "Back to the collection",
    "product.loading": "Preparing this object…",
    "product.gallery": "Product gallery",
    "product.previous": "Previous image",
    "product.next": "Next image",
    "product.configuration": "Make it yours",
    "product.configurationBody":
      "Select the published options to confirm the current price and production specification.",
    "product.summary": "Your selection",
    "product.required": "Required",
    "product.select": "Choose an option",
    "product.validation": "Complete the visible required choices.",
    "product.priceFrom": "Display price",
    "product.publishedPrice": "Published price",
    "product.priceBoundary":
      "Exact configured prices are confirmed by Zoya's server.",
    "product.readyBoundary":
      "This product is published as ready. Cart and checkout are not active yet.",
    "product.readyPurchase":
      "Ready for secure guest checkout while the published allocation lasts.",
    "product.guestReadyOnly":
      "Guest checkout is limited to ready products. Configure this object for an authoritative price preview.",
    "customerDesign.eyebrow": "Customer design",
    "customerDesign.title": "Your design",
    "customerDesign.previewLabel": "Design identity",
    "customerDesign.previewHint":
      "A clear visual preview keeps your request easy to recognize.",
    "customerDesign.previewWaiting": "Your uploaded design will appear here.",
    "customerDesign.previewReady": "Ready for workshop review",
    "customerDesign.step": "01 / 03",
    "customerDesign.upload": "Upload Design",
    "customerDesign.replace": "Replace Design",
    "customerDesign.remove": "Remove Design",
    "customerDesign.notes": "Notes / Instructions",
    "customerDesign.notesHelp":
      "Add any printing, sizing, color, finishing, or design instructions.",
    "customerDesign.policy":
      "PNG, JPEG, WebP, PDF, SVG, STL, OBJ, 3MF, STEP or STP. Up to 25 MB for images, 50 MB for artwork, and 95 MB for 3D/CAD.",
    "customerDesign.empty": "No design selected yet.",
    "customerDesign.uploading": "Uploading and validating your design…",
    "customerDesign.removing": "Removing your design…",
    "customerDesign.uploaded": "Upload complete and ready for review.",
    "customerDesign.error":
      "This file could not be accepted. Check its format, content, and size, then try again.",
    "customerDesign.errorTooLarge":
      "This file is larger than we can accept. Reduce its size or export a lighter version, then try again.",
    "customerDesign.errorType":
      "This file type is not supported. Use PNG, JPEG, WebP, PDF, SVG, STL, OBJ, 3MF, STEP or STP.",
    "customerDesign.errorContent":
      "This file looks damaged, empty, or does not match its extension. Export it again and retry.",
    "customerDesign.errorMalware":
      "Our security check flagged this file, so it was not saved. Scan your device, export a clean copy, and try again.",
    "customerDesign.errorBusy":
      "We could not check your file right now. Please try again in a few minutes.",
    "cart.eyebrow": "Your selection",
    "cart.title": "Cart",
    "cart.items": "items",
    "cart.loading": "Opening your cart…",
    "cart.error": "Your cart could not be updated. Please try again.",
    "cart.empty": "Your cart is ready for something considered.",
    "cart.shop": "Explore the collection",
    "cart.add": "Add to cart",
    "cart.adding": "Adding…",
    "cart.updating": "Updating cart…",
    "cart.removing": "Removing…",
    "cart.repricing": "Checking prices…",
    "cart.quantity": "Quantity for",
    "cart.decrease": "Decrease quantity",
    "cart.increase": "Increase quantity",
    "cart.remove": "Remove",
    "cart.summary": "Order summary",
    "cart.subtotal": "Subtotal",
    "cart.coupon.label": "Discount code",
    "cart.coupon.placeholder": "Enter code",
    "cart.coupon.apply": "Apply",
    "cart.coupon.applying": "Applying…",
    "cart.coupon.remove": "Remove code",
    "cart.coupon.removing": "Removing code…",
    "cart.coupon.discount": "Discount",
    "cart.coupon.total": "Total",
    "cart.coupon.error.COUPON_NOT_FOUND": "That code isn't valid.",
    "cart.coupon.error.COUPON_CODE_INVALID": "Enter a valid code.",
    "cart.coupon.error.COUPON_INACTIVE": "That code is no longer active.",
    "cart.coupon.error.COUPON_NOT_STARTED": "That code isn't active yet.",
    "cart.coupon.error.COUPON_EXPIRED": "That code has expired.",
    "cart.coupon.error.COUPON_BELOW_MINIMUM_SUBTOTAL":
      "Your order doesn't yet meet this code's minimum.",
    "cart.coupon.error.COUPON_REDEMPTION_LIMIT_REACHED":
      "That code has reached its usage limit.",
    "cart.coupon.error.COUPON_CUSTOMER_LIMIT_REACHED":
      "You've already used that code.",
    "cart.coupon.error.COUPON_NO_LONGER_VALID":
      "That code is no longer valid for this order.",
    "cart.coupon.error.generic": "That code couldn't be applied.",
    "cart.deliveryLater":
      "Delivery and payment terms are confirmed at checkout.",
    "cart.checkout": "Continue to checkout",
    "cart.reprice": "Check current prices",
    "cart.priceChanged":
      "Price changed. Accept the current price before checkout.",
    "cart.acceptPrices": "Accept current prices",
    "cart.acceptToCheckout": "Accept prices to continue",
    "checkout.eyebrow": "Secure checkout",
    "checkout.title": "Complete your order",
    "checkout.body":
      "One calm review of contact, delivery and payment. Prices are confirmed by Zoya before the order is created.",
    "checkout.progress": "Checkout progress",
    "checkout.loading": "Preparing secure checkout…",
    "checkout.contact": "Contact",
    "checkout.name": "Full name",
    "checkout.email": "Email",
    "checkout.verifiedEmail": "Uses the verified email from your Zoya account.",
    "checkout.code": "Verification code",
    "checkout.demoCode":
      "Acceptance environment code: 246810. Production requires a configured verification provider.",
    "checkout.delivery": "Delivery",
    "checkout.payment": "Payment",
    "checkout.review": "Review",
    "checkout.addressLine": "Delivery address",
    "checkout.city": "City",
    "checkout.editCart": "Edit cart",
    "checkout.quantityShort": "Qty",
    "checkout.authoritative":
      "The final total is derived from the current authoritative publication and price.",
    "checkout.place": "Place order",
    "checkout.submitting": "Creating order…",
    "checkout.error": "Review the contact verification and checkout choices.",
    "checkout.errorTitle": "Your order was not placed",
    "checkout.stockUnavailable":
      "One of these items is no longer available in the selected quantity. Return to your cart to adjust it.",
    "checkout.priceChanged":
      "A current price needs your approval before checkout. Return to your cart to review it.",
    "checkout.contactNotVerified":
      "Your verified account email could not be confirmed. Sign in again, then retry checkout.",
    "checkout.returnToCart": "Return to cart",
    "delivery.pickup": "Pickup",
    "delivery.pickupBody": "Collect from the confirmed Zoya Cairo location.",
    "delivery.courier": "Courier",
    "delivery.courierBody": "Delivery details are preserved with this order.",
    "payment.online": "Online payment",
    "payment.cod": "Cash on delivery",
    "payment.cash": "Cash",
    "payment.bank_transfer": "Bank transfer",
    "payment.instapay": "InstaPay",
    "paymentHelp.title": "How to pay",
    "paymentHelp.bank":
      "Transfer the order total to this bank account and write your order number in the transfer note.",
    "paymentHelp.bankName": "Bank",
    "paymentHelp.accountName": "Account name",
    "paymentHelp.accountNumber": "Account number / IBAN",
    "paymentHelp.instapay":
      "Send the order total by InstaPay to this address and write your order number in the note.",
    "paymentHelp.instapayAddress": "InstaPay address",
    "paymentHelp.missing":
      "Our team will send you the payment details after you place the order.",
    "paymentHelp.cash":
      "Pay in cash at the workshop when you collect your order.",
    "paymentHelp.confirm":
      "We check transfers by hand, usually within one working day. Your order shows as paid once confirmed.",
    "paymentHelp.reference": "Order number to quote",
    "confirmation.eyebrow": "Order confirmed",
    "confirmation.title": "Thank you. Your order is safely recorded.",
    "confirmation.body":
      "The commercial details below are now immutable evidence.",
    "confirmation.number": "Order number",
    "confirmation.total": "Total",
    "confirmation.payment": "Payment method",
    "confirmation.delivery": "Delivery method",
    "confirmation.next":
      "Zoya will verify the selected payment method and contact you about the next commercial step. No production status is implied yet.",
    "confirmation.orders": "View my orders",
    "confirmation.continue": "Continue shopping",
    "pricing.quantity": "Quantity",
    "pricing.authoritative": "Authoritative price",
    "pricing.currentConfiguration": "Current configuration price",
    "pricing.from": "From",
    "pricing.requestQuote": "Request a Quote",
    "pricing.configureForPrice": "Configure for price",
    "pricing.complete": "Complete the required choices to receive a price.",
    "pricing.loading": "Confirming price…",
    "pricing.error":
      "The price could not be confirmed. Check the choices and try again.",
    "pricing.quoteRequired": "Workshop review and a quotation are required.",
    "pricing.breakdown": "View price breakdown",
    "quotation.eyebrow": "Zoya quotation",
    "quotation.accessTitle": "Open your private quotation",
    "quotation.accessBody":
      "Enter the access code shared with you. It is not stored in this page address.",
    "quotation.accessCode": "Access code",
    "quotation.open": "Open quotation",
    "quotation.loading": "Opening…",
    "quotation.notFound": "The quotation or access code could not be verified.",
    "quotation.title": "Your quotation",
    "quotation.version": "Version",
    "quotation.issued": "Issued",
    "quotation.expires": "Valid until",
    "quotation.total": "Quotation total",
    "quotation.terms": "Terms",
    "quotation.status.issued": "Issued",
    "quotation.status.expired": "Expired",
    "about.eyebrow": "The Zoya workshop",
    "about.title": "Objects begin with a reason.",
    "about.body":
      "Zoya connects considered design with the knowledge of hands. We make and publish only what the workshop can explain, price and produce with care.",
    "about.materialEyebrow": "Our way of making",
    "about.materialTitle": "From material to meaning",
    "about.materialBody":
      "A useful object begins long before production. We understand the need, respect the material and preserve every approved choice through making.",
    "about.step1Title": "Listen first",
    "about.step1Body":
      "We begin with how the object will be used, the space it belongs in and the details that matter to its owner.",
    "about.step2Title": "Shape with honesty",
    "about.step2Body":
      "Dimensions, materials and finishes stay within clear workshop limits, so customization remains genuinely makeable.",
    "about.step3Title": "Publish what we can honor",
    "about.step3Body":
      "Only active, approved products reach the shop. The selected specification and commercial record remain clear after ordering.",
    "about.promiseEyebrow": "What stays true",
    "about.promiseTitle": "Clear choices. Lasting records.",
    "about.promiseBody":
      "Ready objects, configurable pieces, customer designs and early ideas each follow the path that fits them—without disguising a quotation as an instant price.",
    "about.explore": "Explore the collection",
    "about.imageCaption": "Material, proportion and use considered together.",
    "contact.eyebrow": "A clear next step",
    "contact.title": "Let’s find the right way forward.",
    "contact.body":
      "Choose what you need help with. We will keep your product, design or order details attached to the correct Zoya journey.",
    "contact.routes": "Ways to contact Zoya",
    "contact.orderTitle": "An existing order",
    "contact.orderBody":
      "Open your account to review order status and keep the order reference close when requesting help.",
    "contact.orderAction": "View my orders",
    "contact.designTitle": "A design ready to make",
    "contact.designBody":
      "Upload production artwork, choose the available material and dimensions, and include precise workshop notes.",
    "contact.designAction": "Start with your design",
    "contact.ideaTitle": "An idea to scope",
    "contact.ideaBody":
      "Share the intended use, quantity, timing and budget. The workshop will review feasibility before a quotation is issued.",
    "contact.ideaAction": "Share an idea",
    "contact.prepareEyebrow": "Before you begin",
    "contact.prepareTitle": "Bring the useful details",
    "contact.prepareBody":
      "For faster help, include your order reference, required dimensions, preferred material, quantity and target date wherever they apply.",
    "contact.baseLabel": "Workshop base",
    "contact.baseValue": "Cairo, Egypt",
    "footer.scope":
      "Secure carts and authenticated checkout for published products.",
    "footer.craft": "Designed with care in Egypt.",
    "footer.navigation": "Footer navigation",
    "footer.collection": "Collection",
    "footer.browse": "Browse",
    "footer.create": "Create",
    "footer.company": "Zoya",
    "footer.about": "About Zoya",
    "footer.contact": "Contact us",
    "footer.rights": "All rights reserved.",
  },
  ar: {
    "a11y.skip": "تخطي إلى المحتوى",
    "brand.tagline": "قطع مصنوعة لقصتك",
    "nav.home": "الرئيسية",
    "nav.shop": "المتجر",
    "nav.custom": "تصميمك",
    "nav.idea": "من فكرة",
    "nav.about": "عن زويا",
    "nav.contact": "تواصل معنا",
    "nav.open": "فتح التنقل",
    "nav.close": "إغلاق التنقل",
    "nav.locale": "التبديل إلى الإنجليزية",
    "nav.theme": "تغيير نمط الألوان",
    "nav.cart": "فتح السلة",
    "hero.eyebrow": "صنع في مصر وشكل باليد",
    "hero.title": "حرفة لها وجهة نظر.",
    "hero.body":
      "اكتشف قطعاً تدوم، جاهزة الآن أو قابلة للتخصيص لطريقتك في الحياة.",
    "hero.cta": "استكشف المجموعة",
    "home.featured": "مختارات لمساحتك",
    "home.featuredBody": "إصدارات صغيرة وخامات صادقة وتفاصيل تستحق البقاء.",
    "home.forAudience": "مختارات لفئة {audience}",
    "home.forAudienceBody":
      "رتّب صنّاعنا هذه القطع لك. يمكنك تغيير اختيارك في أي وقت.",
    "home.forAudienceEmpty":
      "ما زلنا ننتقي قطعاً لهذه الفئة — إليك أحدث ما لدينا.",
    "audience.eyebrow": "أهلاً بك في زويا",
    "audience.title": "بأي صفة تتسوّق؟",
    "audience.body":
      "اختر الفئة الأقرب إليك وسنعرض لك أولاً القطع المصنوعة لها.",
    "audience.skip": "تخطَّ — اعرض كل شيء",
    "audience.close": "إغلاق وعرض كل شيء",
    "audience.change": "تغيير",
    "audience.choose": "خصّص تجربتك",
    "audience.current": "تتسوّق كـ",
    "home.reel.label": "آخر أخبار زويا",
    "home.reel.eyebrow": "الآن في زويا",
    "home.reel.title": "قطع وملاحظات وأخبار التوصيل",
    "home.reel.body": "نظرة مباشرة على المنشورات وما تستعد له الورشة.",
    "home.reel.pause": "إيقاف حركة الإعلانات",
    "home.reel.resume": "استئناف حركة الإعلانات",
    "home.reel.announcement.label": "ملاحظة الورشة",
    "home.reel.announcement.title": "استكشاف التصميم المخصص متاح",
    "home.reel.announcement.body":
      "ارفع تصميماً جاهزاً للإنتاج من خلال خدمة منشورة، ثم حدد الخامة والأبعاد بسعر يؤكده الخادم.",
    "home.reel.delivery.label": "تحديث التوصيل",
    "home.reel.delivery.title": "تفاصيل التوصيل واضحة",
    "home.reel.delivery.body": "تؤكد مناطق الخدمة والمواعيد قبل إتاحة الطلب.",
    "home.reel.product.label": "قطعة منشورة",
    "home.reel.view": "عرض القطعة",
    "home.categories": "اختر نقطة البداية",
    "home.ready": "قطع جاهزة",
    "home.readyBody": "قطع مكتملة بطابعها الخاص ومتاحة حسب النشر الحالي.",
    "home.customizable": "صنعت لتخصيصك",
    "home.customizableBody": "اختر من خامات وتشطيبات واضحة ومعتمدة من الورشة.",
    "home.story": "نصنع بهدوء. لتستخدم طويلاً.",
    "home.storyBody":
      "تجمع زويا بين التصميم المدروس وخبرة الأيدي. يحمل كل نشر الخيارات الدقيقة التي تستطيع الورشة تنفيذها.",
    "journey.design.title": "أحضر تصميمك",
    "journey.design.body":
      "ارفع ملف الإنتاج الخاص بك مباشرة. هذا الطلب مستقل عن منتجات الكتالوج وتراجعه الورشة قبل عرض السعر أو إنشاء الطلب.",
    "journey.design.cta": "تصفح منتجات تصميم العميل",
    "designRequest.boundary":
      "هذا طلب تصميم خاص وليس منتجاً في الكتالوج أو عنصراً في السلة أو طلب شراء. تؤكد الورشة قابلية التنفيذ والسعر أولاً.",
    "designRequest.eyebrow": "استقبال تصميم مستقل",
    "designRequest.title": "أرسل تصميمك إلى الورشة",
    "designRequest.body":
      "أرفق الملف الدقيق الذي تريد مراجعته وأضف التفاصيل العملية التي تساعد فريق الإنتاج على تقييمه.",
    "designRequest.step1": "ارفع ملف التصميم الخاص بأمان.",
    "designRequest.step2": "أضف الكمية والموعد وملاحظات الإنتاج.",
    "designRequest.step3": "راجع عرض سعر الورشة قبل إنشاء طلب شراء.",
    "designRequest.projectTitle": "عنوان الطلب",
    "designRequest.quantity": "الكمية",
    "designRequest.targetDate": "الموعد المفضل (اختياري)",
    "designRequest.quoteBoundary":
      "الإرسال لا ينشئ طلب شراء ولا يفرض رسوماً. يحدد السعر بعد المراجعة الفنية وعرض سعر صريح.",
    "designRequest.submit": "إرسال التصميم للمراجعة",
    "designRequest.submitting": "جارٍ الإرسال بأمان…",
    "designRequest.success": "تم استلام طلب التصميم. المرجع:",
    "designRequest.error": "تعذر إرسال طلب التصميم",
    "journey.idea.title": "ابدأ بفكرة",
    "journey.idea.body":
      "استكشف خدمات التحويل من فكرة إلى منتج. الأعمال التي تحتاج مراجعة بشرية تبقى واضحة كطلب عرض سعر ولا تعرض سعراً فورياً مضللاً.",
    "journey.idea.cta": "تصفح خدمات من فكرة إلى منتج",
    "ideaRequest.eyebrow": "استقبال الورشة بعرض سعر أولاً",
    "ideaRequest.title": "أخبرنا بما تريد تنفيذه",
    "ideaRequest.body":
      "شارك وصفاً واضحاً. تراجع الورشة قابلية التنفيذ والخامات والموعد والسعر قبل إنشاء أي طلب تجاري.",
    "ideaRequest.step1": "أرسل الفكرة والمتطلبات العملية.",
    "ideaRequest.step2": "يسند المشرف الوصف للمراجعة الفنية.",
    "ideaRequest.step3": "راجع عرض السعر واقبله قبل بدء الإنتاج.",
    "ideaRequest.projectTitle": "عنوان المشروع",
    "ideaRequest.description": "الفكرة ومتطلبات الإنتاج",
    "ideaRequest.quantity": "الكمية",
    "ideaRequest.targetDate": "الموعد المفضل (اختياري)",
    "ideaRequest.budget": "الميزانية بالجنيه (اختياري)",
    "ideaRequest.quoteBoundary":
      "هذا طلب مراجعة وليس طلب شراء أو دفعاً. ينشأ الطلب فقط بعد قبول عرض السعر.",
    "ideaRequest.submit": "إرسال الفكرة للمراجعة",
    "ideaRequest.submitting": "جارٍ الإرسال بأمان…",
    "ideaRequest.unavailable": "خدمة الأفكار غير متاحة حالياً",
    "ideaRequest.success": "تم استلام الطلب. المرجع:",
    "ideaRequest.error": "تعذر إرسال الطلب",
    "journey.boundary":
      "تظهر هنا منشورات الورشة النشطة فقط. يؤكد النشر الحالي السعر وإمكانية التصنيع.",
    "journey.offerings": "طرق البدء المتاحة",
    "journey.offeringsBody":
      "اختر خدمة منشورة لمراجعة المتطلبات والإتاحة ومسار التسعير.",
    "catalog.eyebrow": "النشر الحالي",
    "catalog.title": "قطع ذات أصل واضح",
    "catalog.body": "تصفح فقط منشورات زويا النشطة. مسودات الورشة لا تظهر هنا.",
    "catalog.all": "الكل",
    "catalog.ready": "جاهز",
    "catalog.customizable": "قابل للتخصيص",
    "catalog.customerDesign": "تصميمك",
    "catalog.idea": "من فكرة",
    "catalog.typeFilter": "نوع المنتج",
    "catalog.filters": "تصفية المجموعة",
    "catalog.filterBody": "اختر مساراً ثم حدد نطاق السعر.",
    "catalog.search": "بحث",
    "catalog.searchPlaceholder": "ابحث في المجموعة",
    "catalog.searchButton": "بحث",
    "catalog.clearSearch": "مسح البحث",
    "catalog.sort": "ترتيب حسب",
    "catalog.sortNewest": "الأحدث",
    "catalog.sortPriceAsc": "السعر: من الأقل إلى الأعلى",
    "catalog.sortPriceDesc": "السعر: من الأعلى إلى الأقل",
    "catalog.price": "السعر",
    "catalog.minPrice": "الحد الأدنى للسعر (EGP)",
    "catalog.maxPrice": "الحد الأقصى للسعر (EGP)",
    "catalog.priceHelp":
      "أدخل مبلغاً صحيحاً بالجنيه. تختفي المنتجات التي تتطلب عرض سعر عند تطبيق نطاق سعري.",
    "catalog.priceInvalid": "أدخل مبلغاً صحيحاً غير سالب بالجنيه.",
    "catalog.priceInverted":
      "يجب أن يكون الحد الأقصى أكبر من الحد الأدنى أو مساوياً له.",
    "catalog.applyPrice": "تطبيق السعر",
    "catalog.clearPrice": "مسح السعر",
    "catalog.loading": "نجهز المجموعة",
    "catalog.results": "قطعة منشورة",
    "catalog.resultsTitle": "المجموعة المنشورة",
    "catalog.imagePending": "الصورة قريباً",
    "catalog.empty": "لا توجد قطع نشطة تطابق هذا العرض.",
    "catalog.error": "تعذر تحميل المجموعة.",
    "action.retry": "حاول مرة أخرى",
    "action.view": "عرض القطعة",
    "action.configure": "خصص القطعة",
    "action.quote": "طلب عرض سعر",
    "action.unavailable": "غير متاح مؤقتاً",
    "product.back": "العودة إلى المجموعة",
    "product.loading": "جارٍ تجهيز هذا المنتج…",
    "product.gallery": "معرض صور المنتج",
    "product.previous": "الصورة السابقة",
    "product.next": "الصورة التالية",
    "product.configuration": "اجعلها لك",
    "product.configurationBody":
      "اختر الخيارات المنشورة لتأكيد السعر الحالي ومواصفات الإنتاج.",
    "product.summary": "اختياراتك",
    "product.required": "مطلوب",
    "product.select": "اختر",
    "product.validation": "أكمل الاختيارات المطلوبة والظاهرة.",
    "product.priceFrom": "سعر العرض",
    "product.publishedPrice": "السعر المنشور",
    "product.priceBoundary": "يؤكد خادم زويا سعر التخصيص الدقيق.",
    "product.readyBoundary":
      "هذه القطعة منشورة كقطعة جاهزة. السلة والدفع غير متاحين بعد.",
    "product.readyPurchase":
      "جاهزة للدفع الآمن كزائر ما دامت الكمية المنشورة متاحة.",
    "product.guestReadyOnly":
      "الدفع كزائر متاح للقطع الجاهزة فقط. خصص هذه القطعة لمعاينة السعر المعتمد.",
    "customerDesign.eyebrow": "تصميم العميل",
    "customerDesign.title": "تصميمك",
    "customerDesign.previewLabel": "هوية التصميم",
    "customerDesign.previewHint":
      "تجعل المعاينة الواضحة طلبك سهل التعرّف عليه.",
    "customerDesign.previewWaiting": "سيظهر التصميم الذي رفعته هنا.",
    "customerDesign.previewReady": "جاهز لمراجعة الورشة",
    "customerDesign.step": "٠١ / ٠٣",
    "customerDesign.upload": "رفع التصميم",
    "customerDesign.replace": "استبدال التصميم",
    "customerDesign.remove": "إزالة التصميم",
    "customerDesign.notes": "ملاحظات / تعليمات",
    "customerDesign.notesHelp":
      "أضف أي تعليمات للطباعة أو المقاس أو اللون أو التشطيب أو التصميم.",
    "customerDesign.policy":
      "PNG أو JPEG أو WebP أو PDF أو SVG أو STL أو OBJ أو 3MF أو STEP أو STP. حتى 25 م.ب للصور، و50 م.ب للأعمال الفنية، و95 م.ب لملفات 3D/CAD.",
    "customerDesign.empty": "لم يتم اختيار تصميم بعد.",
    "customerDesign.uploading": "جارٍ رفع التصميم والتحقق منه…",
    "customerDesign.removing": "جارٍ حذف التصميم…",
    "customerDesign.uploaded": "اكتمل الرفع وأصبح التصميم جاهزًا للمراجعة.",
    "customerDesign.error":
      "تعذر قبول هذا الملف. تحقق من الصيغة والمحتوى والحجم ثم حاول مرة أخرى.",
    "customerDesign.errorTooLarge":
      "حجم هذا الملف أكبر من المسموح. قلّل حجمه أو صدّر نسخة أخف ثم حاول مرة أخرى.",
    "customerDesign.errorType":
      "نوع هذا الملف غير مدعوم. استخدم PNG أو JPEG أو WebP أو PDF أو SVG أو STL أو OBJ أو 3MF أو STEP أو STP.",
    "customerDesign.errorContent":
      "يبدو أن هذا الملف تالف أو فارغ أو لا يطابق امتداده. صدّره مرة أخرى ثم أعد المحاولة.",
    "customerDesign.errorMalware":
      "أوقف الفحص الأمني هذا الملف ولم يتم حفظه. افحص جهازك وصدّر نسخة سليمة ثم حاول مرة أخرى.",
    "customerDesign.errorBusy":
      "تعذر فحص ملفك الآن. يرجى المحاولة مرة أخرى بعد بضع دقائق.",
    "cart.eyebrow": "اختياراتك",
    "cart.title": "السلة",
    "cart.items": "قطع",
    "cart.loading": "نفتح سلتك…",
    "cart.error": "تعذر تحديث سلتك. حاول مرة أخرى.",
    "cart.empty": "سلتك جاهزة لاختيار قطعة مدروسة.",
    "cart.shop": "استكشف المجموعة",
    "cart.add": "أضف إلى السلة",
    "cart.adding": "جارٍ الإضافة…",
    "cart.updating": "جارٍ تحديث السلة…",
    "cart.removing": "جارٍ الحذف…",
    "cart.repricing": "جارٍ التحقق من الأسعار…",
    "cart.quantity": "كمية",
    "cart.decrease": "تقليل الكمية",
    "cart.increase": "زيادة الكمية",
    "cart.remove": "إزالة",
    "cart.summary": "ملخص الطلب",
    "cart.subtotal": "المجموع الفرعي",
    "cart.coupon.label": "كود الخصم",
    "cart.coupon.placeholder": "أدخل الكود",
    "cart.coupon.apply": "تطبيق",
    "cart.coupon.applying": "جارٍ التطبيق…",
    "cart.coupon.remove": "إزالة الكود",
    "cart.coupon.removing": "جارٍ إزالة الكود…",
    "cart.coupon.discount": "الخصم",
    "cart.coupon.total": "الإجمالي",
    "cart.coupon.error.COUPON_NOT_FOUND": "هذا الكود غير صالح.",
    "cart.coupon.error.COUPON_CODE_INVALID": "أدخل كودًا صالحًا.",
    "cart.coupon.error.COUPON_INACTIVE": "لم يعد هذا الكود مفعّلاً.",
    "cart.coupon.error.COUPON_NOT_STARTED": "لم يبدأ تفعيل هذا الكود بعد.",
    "cart.coupon.error.COUPON_EXPIRED": "انتهت صلاحية هذا الكود.",
    "cart.coupon.error.COUPON_BELOW_MINIMUM_SUBTOTAL":
      "طلبك لم يصل بعد إلى الحد الأدنى لهذا الكود.",
    "cart.coupon.error.COUPON_REDEMPTION_LIMIT_REACHED":
      "وصل هذا الكود إلى الحد الأقصى للاستخدام.",
    "cart.coupon.error.COUPON_CUSTOMER_LIMIT_REACHED":
      "لقد استخدمت هذا الكود من قبل.",
    "cart.coupon.error.COUPON_NO_LONGER_VALID":
      "لم يعد هذا الكود صالحًا لهذا الطلب.",
    "cart.coupon.error.generic": "تعذر تطبيق هذا الكود.",
    "cart.deliveryLater": "تؤكد تفاصيل التوصيل والدفع عند إتمام الطلب.",
    "cart.checkout": "المتابعة لإتمام الطلب",
    "cart.reprice": "تحقق من الأسعار الحالية",
    "cart.priceChanged": "تغير السعر. اقبل السعر الحالي قبل إتمام الطلب.",
    "cart.acceptPrices": "اقبل الأسعار الحالية",
    "cart.acceptToCheckout": "اقبل الأسعار للمتابعة",
    "checkout.eyebrow": "دفع آمن",
    "checkout.title": "أكمل طلبك",
    "checkout.body":
      "مراجعة هادئة واحدة لبيانات التواصل والتوصيل والدفع. تؤكد زويا السعر قبل إنشاء الطلب.",
    "checkout.progress": "مراحل إتمام الطلب",
    "checkout.loading": "نجهز الدفع الآمن…",
    "checkout.contact": "التواصل",
    "checkout.name": "الاسم الكامل",
    "checkout.email": "البريد الإلكتروني",
    "checkout.verifiedEmail":
      "يُستخدم البريد الإلكتروني المؤكد في حساب زويا الخاص بك.",
    "checkout.code": "رمز التحقق",
    "checkout.demoCode":
      "رمز بيئة القبول: 246810. يتطلب الإنتاج مزود تحقق مهيأ.",
    "checkout.delivery": "التوصيل",
    "checkout.payment": "الدفع",
    "checkout.review": "المراجعة",
    "checkout.addressLine": "عنوان التوصيل",
    "checkout.city": "المدينة",
    "checkout.editCart": "تعديل السلة",
    "checkout.quantityShort": "الكمية",
    "checkout.authoritative":
      "يحسب المجموع النهائي من النشر والسعر المعتمدين حالياً.",
    "checkout.place": "تأكيد الطلب",
    "checkout.submitting": "جارٍ إنشاء الطلب…",
    "checkout.error": "راجع تحقق التواصل واختيارات إتمام الطلب.",
    "checkout.errorTitle": "لم يتم إنشاء طلبك",
    "checkout.stockUnavailable":
      "إحدى القطع لم تعد متاحة بالكمية المختارة. ارجع إلى السلة لتعديلها.",
    "checkout.priceChanged":
      "يوجد سعر حالي يحتاج موافقتك قبل إتمام الطلب. ارجع إلى السلة لمراجعته.",
    "checkout.contactNotVerified":
      "تعذر تأكيد بريد حسابك الموثق. سجل الدخول مرة أخرى ثم أعد محاولة إتمام الطلب.",
    "checkout.returnToCart": "العودة إلى السلة",
    "delivery.pickup": "استلام",
    "delivery.pickupBody": "استلم من موقع زويا المؤكد في القاهرة.",
    "delivery.courier": "مندوب توصيل",
    "delivery.courierBody": "تحفظ بيانات التوصيل تاريخياً مع الطلب.",
    "payment.online": "دفع إلكتروني",
    "payment.cod": "الدفع عند الاستلام",
    "payment.cash": "نقدي",
    "payment.bank_transfer": "تحويل بنكي",
    "payment.instapay": "إنستا باي",
    "paymentHelp.title": "طريقة الدفع",
    "paymentHelp.bank":
      "حوّل إجمالي الطلب إلى هذا الحساب البنكي واكتب رقم طلبك في ملاحظة التحويل.",
    "paymentHelp.bankName": "البنك",
    "paymentHelp.accountName": "اسم الحساب",
    "paymentHelp.accountNumber": "رقم الحساب / IBAN",
    "paymentHelp.instapay":
      "أرسل إجمالي الطلب عبر إنستا باي إلى هذا العنوان واكتب رقم طلبك في الملاحظة.",
    "paymentHelp.instapayAddress": "عنوان إنستا باي",
    "paymentHelp.missing": "سيرسل لك فريقنا بيانات الدفع بعد تأكيد الطلب.",
    "paymentHelp.cash": "ادفع نقدًا في الورشة عند استلام طلبك.",
    "paymentHelp.confirm":
      "نراجع التحويلات يدويًا، عادةً خلال يوم عمل واحد. يظهر طلبك مدفوعًا بعد التأكيد.",
    "paymentHelp.reference": "رقم الطلب المطلوب كتابته",
    "confirmation.eyebrow": "تم تأكيد الطلب",
    "confirmation.title": "شكراً لك. سجل طلبك بأمان.",
    "confirmation.body": "أصبحت التفاصيل التجارية التالية سجلاً ثابتاً.",
    "confirmation.number": "رقم الطلب",
    "confirmation.total": "الإجمالي",
    "confirmation.payment": "طريقة الدفع",
    "confirmation.delivery": "طريقة التوصيل",
    "confirmation.next":
      "ستتحقق زويا من طريقة الدفع المختارة وتتواصل معك بشأن الخطوة التجارية التالية. لا يعني ذلك بدء الإنتاج بعد.",
    "confirmation.orders": "عرض طلباتي",
    "confirmation.continue": "متابعة التسوق",
    "pricing.quantity": "الكمية",
    "pricing.authoritative": "السعر المعتمد",
    "pricing.currentConfiguration": "سعر التخصيص الحالي",
    "pricing.from": "ابتداءً من",
    "pricing.requestQuote": "طلب عرض سعر",
    "pricing.configureForPrice": "خصص لمعرفة السعر",
    "pricing.complete": "أكمل الاختيارات المطلوبة للحصول على السعر.",
    "pricing.loading": "جارٍ تأكيد السعر…",
    "pricing.error": "تعذر تأكيد السعر. راجع الاختيارات وحاول مرة أخرى.",
    "pricing.quoteRequired": "يلزم مراجعة الورشة وإصدار عرض سعر.",
    "pricing.breakdown": "عرض تفاصيل السعر",
    "quotation.eyebrow": "عرض سعر زويا",
    "quotation.accessTitle": "افتح عرض السعر الخاص بك",
    "quotation.accessBody":
      "أدخل رمز الوصول المرسل إليك. لا يُحفظ الرمز في عنوان الصفحة.",
    "quotation.accessCode": "رمز الوصول",
    "quotation.open": "فتح عرض السعر",
    "quotation.loading": "جارٍ الفتح…",
    "quotation.notFound": "تعذر التحقق من عرض السعر أو رمز الوصول.",
    "quotation.title": "عرض السعر الخاص بك",
    "quotation.version": "الإصدار",
    "quotation.issued": "تاريخ الإصدار",
    "quotation.expires": "صالح حتى",
    "quotation.total": "إجمالي عرض السعر",
    "quotation.terms": "الشروط",
    "quotation.status.issued": "صادر",
    "quotation.status.expired": "منتهي الصلاحية",
    "about.eyebrow": "ورشة زويا",
    "about.title": "كل قطعة تبدأ بسبب.",
    "about.body":
      "تصل زويا بين التصميم المدروس وخبرة الأيدي. نصنع وننشر فقط ما تستطيع الورشة شرحه وتسعيره وتنفيذه بعناية.",
    "about.materialEyebrow": "طريقتنا في الصنع",
    "about.materialTitle": "من الخامة إلى المعنى",
    "about.materialBody":
      "تبدأ القطعة النافعة قبل الإنتاج بوقت طويل. نفهم الحاجة ونحترم الخامة ونحفظ كل اختيار معتمد خلال التصنيع.",
    "about.step1Title": "نستمع أولاً",
    "about.step1Body":
      "نبدأ بكيفية استخدام القطعة والمساحة التي ستنتمي إليها والتفاصيل المهمة لصاحبها.",
    "about.step2Title": "نشكّل بوضوح",
    "about.step2Body":
      "تبقى الأبعاد والخامات والتشطيبات ضمن حدود الورشة الواضحة، ليظل التخصيص قابلاً للتنفيذ فعلاً.",
    "about.step3Title": "ننشر ما نستطيع الالتزام به",
    "about.step3Body":
      "لا يصل إلى المتجر إلا المنتج النشط والمعتمد. وتبقى المواصفات المختارة والسجل التجاري واضحين بعد الطلب.",
    "about.promiseEyebrow": "ما يبقى ثابتاً",
    "about.promiseTitle": "اختيارات واضحة. وسجل يدوم.",
    "about.promiseBody":
      "لكل من القطع الجاهزة والقابلة للتخصيص وتصاميم العملاء والأفكار المبكرة مسار يناسبها، دون عرض طلب التسعير كسعر فوري مضلل.",
    "about.explore": "استكشف المجموعة",
    "about.imageCaption": "الخامة والنسب والاستخدام تُدرس معاً.",
    "contact.eyebrow": "خطوة تالية واضحة",
    "contact.title": "لنجد الطريق الصحيح للبدء.",
    "contact.body":
      "اختر نوع المساعدة التي تحتاجها. سنبقي تفاصيل منتجك أو تصميمك أو طلبك مرتبطة بمسار زويا الصحيح.",
    "contact.routes": "طرق التواصل مع زويا",
    "contact.orderTitle": "طلب قائم",
    "contact.orderBody":
      "افتح حسابك لمراجعة حالة الطلب واحتفظ بمرجع الطلب عند طلب المساعدة.",
    "contact.orderAction": "عرض طلباتي",
    "contact.designTitle": "تصميم جاهز للتنفيذ",
    "contact.designBody":
      "ارفع ملف الإنتاج واختر الخامة والأبعاد المتاحة وأضف ملاحظات واضحة للورشة.",
    "contact.designAction": "ابدأ بتصميمك",
    "contact.ideaTitle": "فكرة تحتاج دراسة",
    "contact.ideaBody":
      "شارك الاستخدام المقصود والكمية والموعد والميزانية. تراجع الورشة إمكانية التنفيذ قبل إصدار عرض السعر.",
    "contact.ideaAction": "شارك فكرتك",
    "contact.prepareEyebrow": "قبل أن تبدأ",
    "contact.prepareTitle": "جهّز التفاصيل المفيدة",
    "contact.prepareBody":
      "للحصول على مساعدة أسرع، أضف مرجع الطلب والأبعاد المطلوبة والخامة المفضلة والكمية والموعد المستهدف حيث تنطبق.",
    "contact.baseLabel": "مقر الورشة",
    "contact.baseValue": "القاهرة، مصر",
    "footer.scope": "سلال آمنة وإتمام طلب موثّق للمنتجات المنشورة.",
    "footer.craft": "صمم بعناية في مصر.",
    "footer.navigation": "تنقل التذييل",
    "footer.collection": "المجموعة",
    "footer.browse": "تصفح",
    "footer.create": "اصنع",
    "footer.company": "زويا",
    "footer.about": "عن زويا",
    "footer.contact": "تواصل معنا",
    "footer.rights": "جميع الحقوق محفوظة.",
  },
} as const;
